export default class Dependencia {

    constructor(declarante={}, dependente={}, grau='', id=null, rendas=[]) {
        this.declarante = declarante;
        this.dependente = dependente;
        this.grau = grau;
        this.id = id;
        this.rendas = rendas;
    }
}


// WEBPACK FOOTER //
// ./src/domain/dependencia/index.js